import React from "react";
import { Provider } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { Helmet } from "react-helmet";
import ScrollToTop from "common/ScrollToTop";
import store from "state/store";
// import NotFoundPage from "pages/404";
import { BreakpointProvider } from "components/common/wrappers/withBreakpoint";
import IQLanding from "./pages/IQ/Landing";

const AppIQ = () => {
  return (
    <Router>
      <Provider store={store}>
        <BreakpointProvider>
          <Helmet />
          <ScrollToTop />
          <Switch>
            <Route
              sensitive
              path="/:anything*([A-Z]):anything*/"
              render={(props) => (
                <Redirect to={`${props.location.pathname.toLowerCase()}`} />
              )}
            />
            <Route exact path="/" component={IQLanding} />
          </Switch>
        </BreakpointProvider>
      </Provider>
    </Router>
  );
};

export default AppIQ;
